var _a, _b, _c, _d, _e;
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./enabledAccount.constants";
// No generator actions: neither endpoint has the shape the generators assume. The list
// returns a flat array rather than the paged {items, meta, links} envelope, and the count
// is nested under a user id rather than keyed by a query, so both are custom below.
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["AddEnabledAccount"] = "ADD_ENABLED_ACCOUNT";
    EActionCustom["GetEnabledAccounts"] = "GET_ENABLED_ACCOUNTS";
    EActionCustom["GetEnabledAccountsCount"] = "GET_ENABLED_ACCOUNTS_COUNT";
    EActionCustom["RemoveEnabledAccount"] = "REMOVE_ENABLED_ACCOUNT";
    EActionCustom["UseEnabledAccount"] = "USE_ENABLED_ACCOUNT";
})(EActionCustom || (EActionCustom = {}));
var generateGetEnabledAccountsActions = function () { return ({
    getEnabledAccountsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetEnabledAccounts,
        state: EActionState.Start,
    }),
    getEnabledAccountsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetEnabledAccounts,
        state: EActionState.Success,
    }),
    getEnabledAccountsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetEnabledAccounts,
        state: EActionState.Fail,
    }),
}); };
var generateGetEnabledAccountsCountActions = function () { return ({
    getEnabledAccountsCountStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetEnabledAccountsCount,
        state: EActionState.Start,
    }),
    getEnabledAccountsCountSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetEnabledAccountsCount,
        state: EActionState.Success,
    }),
    getEnabledAccountsCountFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetEnabledAccountsCount,
        state: EActionState.Fail,
    }),
}); };
var generateAddEnabledAccountActions = function () { return ({
    addEnabledAccountStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddEnabledAccount,
        state: EActionState.Start,
    }),
    addEnabledAccountSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddEnabledAccount,
        state: EActionState.Success,
    }),
    addEnabledAccountFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddEnabledAccount,
        state: EActionState.Fail,
    }),
}); };
var generateRemoveEnabledAccountActions = function () { return ({
    removeEnabledAccountStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveEnabledAccount,
        state: EActionState.Start,
    }),
    removeEnabledAccountSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveEnabledAccount,
        state: EActionState.Success,
    }),
    removeEnabledAccountFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveEnabledAccount,
        state: EActionState.Fail,
    }),
}); };
var generateUseEnabledAccountActions = function () { return ({
    useEnabledAccountStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UseEnabledAccount,
        state: EActionState.Start,
    }),
    useEnabledAccountSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UseEnabledAccount,
        state: EActionState.Success,
    }),
    useEnabledAccountFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UseEnabledAccount,
        state: EActionState.Fail,
    }),
}); };
export var addEnabledAccountStart = (_a = generateAddEnabledAccountActions(), _a.addEnabledAccountStart), addEnabledAccountSucceeded = _a.addEnabledAccountSucceeded, addEnabledAccountFailed = _a.addEnabledAccountFailed;
export var getEnabledAccountsStart = (_b = generateGetEnabledAccountsActions(), _b.getEnabledAccountsStart), getEnabledAccountsSucceeded = _b.getEnabledAccountsSucceeded, getEnabledAccountsFailed = _b.getEnabledAccountsFailed;
export var getEnabledAccountsCountStart = (_c = generateGetEnabledAccountsCountActions(), _c.getEnabledAccountsCountStart), getEnabledAccountsCountSucceeded = _c.getEnabledAccountsCountSucceeded, getEnabledAccountsCountFailed = _c.getEnabledAccountsCountFailed;
export var removeEnabledAccountStart = (_d = generateRemoveEnabledAccountActions(), _d.removeEnabledAccountStart), removeEnabledAccountSucceeded = _d.removeEnabledAccountSucceeded, removeEnabledAccountFailed = _d.removeEnabledAccountFailed;
export var useEnabledAccountStart = (_e = generateUseEnabledAccountActions(), _e.useEnabledAccountStart), useEnabledAccountSucceeded = _e.useEnabledAccountSucceeded, useEnabledAccountFailed = _e.useEnabledAccountFailed;
